import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrganisationProfileFunctionApiService extends ApiService {
  readonly resourcePath = 'organisation_profile_functions';

  create(data:object){
    return this.restCreate<any>(data);
  }

  update(id: string, data: object): Observable<any> {
    return this.restUpdate<any>(id, data);
  }

  delete(id:string){
    return this.restDelete(id);
  }
}
